export default __webpack_public_path__ + "static/media/liked_black.52cb9593.svg";